<div>
    <h3 class="st-h-title">{{ "Subtotal" | translate }}</h3>
    <div class="st-h-container">
        <div class="st-h-left">
            <div class="st-h-l-occup">
                {{ "For" | translate }} {{ occupancyString }}
            </div>
            <div>{{ roomName }}</div>
            <div>{{ mealPlanType }}</div>
        </div>
        <div class="st-h-right">
            <div class="st-h-r-full-price">
                {{
                    fullPrice
                        | currency
                            : currencySymbol
                            : "symbol"
                            : "1.0-0"
                            : locale
                }}
            </div>
            <div class="st-h-r-price">
                {{
                    price
                        | currency
                            : currencySymbol
                            : "symbol"
                            : "1.0-0"
                            : locale
                }}
            </div>
            <div class="st-h-r-you-save">
                {{ "Save_money" | translate }}
                <b>{{
                    fullPrice - price
                        | currency
                            : currencySymbol
                            : "symbol"
                            : "1.0-0"
                            : locale
                }}</b>
            </div>
        </div>
    </div>
</div>
